export default __webpack_public_path__ + "static/media/woman-large.6234d8ef.webp";